import { authHeader, httpHelper } from '../helpers';
import { post, get } from 'axios';

export const commonService = {
    findAllCodeTree,
    findAllGradeList,
    findByGroupCode,
    findGoupCodes,
    findOrgCodes,
    findRegionCodes,
    findOfficeCodes,
    findOpbTypeCodes,
    findOpbStatusCodes,
    listCapture,
    downloadFile
};

function findAllCodeTree() {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/common/findAllCodeTree`, headers);
}

function findAllGradeList() {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/common/findAllGradeList`, headers);
}

function findByGroupCode(groupCode) {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/common/findByGroupCode/${groupCode}`, headers);
}

function findGoupCodes() {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/common/findGroupCodes`, headers);
}

function findOrgCodes() {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/common/findOrgCodes`, headers);
}

function findRegionCodes() {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/common/findRegionCodes`, headers);
}

function findOfficeCodes(orgCode) {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/common/findOfficeCodes/${orgCode}`, headers);
}

function findOpbTypeCodes(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/common/findOpbTypeCodes`, formData, headers);
}

function findOpbStatusCodes() {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/common/findOpbStatusCodes`, headers);
}

function listCapture(formData) {
    const headers = {headers: authHeader()};
    return post(httpHelper.getApiUrl()+`/common/listCapture`, formData, headers);
}

function downloadFile(imei) {
    const headers = {headers: authHeader(), responseType: 'arraybuffer'};
    return get(httpHelper.getApiUrl()+`/common/download/${imei}`, headers);
}
